import {
  OrderDirection,
  userDetails,
} from "../../../../../../../utils/commonQueryTypes";
import { TicketStatus } from "../../../../../../../utils/constants";
import {
  JunctionStatus,
  PriorityEnum,
} from "../../../../../../../utils/Enum.types";
import { IObjectKeys } from "../../../../../../../utils/formTypes";
import { AtsCompany } from "../../../../../customer/companies/queries/types";
import { MstCustomer } from "../../../../../customer/queries/types";
import { EmpMaster } from "../../../../users/queries/types";
import { AtsAcLdgr } from "../../../supplier/queries/types";
import {
  AtsSubsidiaryOrderField,
  AtsSubsidiarySite,
} from "../../queries/types";
import { PriorityType } from "../viewjunctions/queries/types";

export interface Junction {
  id: number;
  name: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  code: string;
  latitude: string;
  longitude: string;
  priority: PriorityEnum;
  alias: string;
  jType: string;
  arms: number;
  icon: string;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
  ldgrID: number;
  poles: number;
  vendorDetails: AtsAcLdgr;
  company: AtsCompany;
  customer: MstCustomer;
  site: AtsSubsidiarySite;
  subsidiary: EmpMaster;
  ticketStatus: TicketStatus;
  junctionStatus: JunctionStatus;
  remarks: string;
  isLocValidated: boolean;
  images: string;
}

export interface PageInfo {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor: string;
  endCursor: string;
}

export interface JunctionEdge {
  node: Junction;
}

export interface GetJunctionsData {
  GetJunctions: {
    edges: JunctionEdge[];
    pageInfo: PageInfo;
    totalCount: number;
  };
}

export enum JunctionQueryType {
  ALL = "ALL",
  GEO_VALIDATED = "GEO_VALIDATED",
  GEO_NOT_VALIDATED = "GEO_NOT_VALIDATED",
}

export interface GetJunctionsVars {
  token?: string;
  after: string | null;
  first: number;
  customerID: number;
  companyID: number;
  subsidiaryID: number;
  empID: number;
  siteID: number;
  jType?: string[];
  ldgrID?: number;
  queryType: JunctionQueryType;
  orderBy: {
    direction: OrderDirection;
    field: AtsSubsidiaryOrderField;
  };
  name: string;
  priority?: PriorityEnum[];
  ticketStatus?: TicketStatus[];
  junctionStatus?: JunctionStatus[];
  startDate?: string;
  endDate?: string;
}

export interface DeleteJunctionVars {
  token?: string;
  junctionID: number;
  user_details: userDetails;
}

export interface DeleteJunctionResult {
  DeleteJunction: boolean;
}

export interface AddJunctionResult {
  AddJunction: boolean;
}

export interface AddJunctionVars {
  token?: string;
  customerID: number;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
  input: CreateAtsJunctionsInput;
  user_details: userDetails;
}
export interface CreateAtsJunctionsFormType extends IObjectKeys {
  name: string;
  code: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  latitude: string;
  longitude: string;
  priority: string;
  alias: string;
  jType: string;
  arms: number;
  icon: string;
  poles: number;
  ldgrID: number;
  junctionStatus: JunctionStatus | null;
  remarks: string;
}

export interface CreateAtsJunctionsInput {
  name: string;
  code: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  latitude: number;
  longitude: number;
  priority: PriorityEnum;
  alias: string;
  jType: string;
  arms: number;
  icon: string;
  poles: number;
  ldgrID: number;
  junctionStatus: JunctionStatus;
  remarks: string;
}

export interface UpdateAtsJunctionsInput {
  name: string;
  code: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  country: string;
  latitude: number;
  longitude: number;
  priority: PriorityEnum;
  alias: string;
  jType: string;
  arms: number;
  icon: string;
  poles: number;
  ldgrID: number;
  junctionStatus: JunctionStatus;
  remarks: string;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
}

export interface UpdateJunctionVars {
  token?: string;
  junctionID: number;
  user_details: userDetails;
  input: UpdateAtsJunctionsInput;
}

export interface UpdateJunctionResult {
  UpdateJunction: boolean;
}

export interface ValidateJunctionForImportVariables {
  token?: string;
  customerID: number;
  companyID: number;
  subsidiaryName: string;
  siteName: string;
  junctionName: string;
}

export interface ValidateJunctionForImportResult {
  ValidateJunctionForImport: boolean;
}

export interface ImportJunctionDetails {
  subsidiaryName: string;
  siteName: string;
  junction: string;
  vendor: string;
  code: string;
  address: string;
  place: string;
  state: string;
  pin: string;
  priority: PriorityEnum;
  country: string;
  alias: string;
  jType: string;
  arms: number;
  icon: string;
  latitude: string;
  longitude: string;
  poles: number;
}

export interface ImportJunctionsResult {
  ImportJunctions: boolean;
}

export interface ImportJunctionsVars {
  token?: string;
  customerID: number;
  companyID: number;
  subsidiaryID: number;
  siteID: number;
  input: ImportJunctionDetails;
  user_details: userDetails;
}

export interface ExportJunctionTemplateData {
  ExportJunctionTemplate: string;
}

export interface ExportJunctionTemplateVars {
  token?: string;
  customerID: number;
  atSiteLevel: boolean;
}

export interface getSubOrSiteOrJunctionByIdResult {
  id: number;
  name: string;
}

export interface GetJunctionCountersVars {
  token: string;
  customerID: number;
  empID: number;
  byJType: boolean;
}

export interface GetJunctionCountersList {
  jType: string;
  vendor_name: string;
  totalJunctions: number;
  working: number;
  notWorking: number;
  planned: number;
  inProgress: number;
  installed: number;
  shifting: number;
  commissioned: number;
  deCommissioned: number;
}
export interface GetJunctionCountersData {
  GetJunctionCounters: GetJunctionCountersList[];
}

export interface MomProjectDetails {
  projectID: string;
  projectName: string;
  vendorName: string;
  pmuCount: number;
  vendorRespCount: number;
  momExists: boolean;
  viewed: boolean;
}
export interface GetProjectsForMomData {
  GetProjectsForMom: MomProjectDetails[];
}

export interface GetProjectsForMomVars {
  customerID: number;
  empID: number;
  momID: number;
  latest: boolean;
}

export interface BulkAlterAtsJunctionsInput {
  name: string;
  code?: string;
  address?: string;
  place?: string;
  state?: string;
  pin?: string;
  country?: string;
  alias?: string;
  jType?: string;
  arms?: number;
  poles?: number;
  latitude?: string;
  longitude?: string;
  remarks?: string;
  companyName?: string;
  subsidiaryName?: string;
  siteName?: string;
  junctionStatus?: JunctionStatus;
  priority?: PriorityType;
}

export interface BulkAlterAtsJunctionsVar {
  token?: string;
  junctionID: number;
  customerID: number;
  user_details: userDetails;
  input: BulkAlterAtsJunctionsInput;
}

export interface BulkAlterAtsJunctionsResult {
  BulkAlterJunctions: true;
}

export interface ExportJunctionsVars {
  customerID: number;
}

export interface ExportJunctionsData {
  ExportJunctions: string;
}


export interface GetJunctionWithOutTokenVar{
  token?: string
  junctionId: number
}


export interface AtsJunctions {
  id: number;
    name: string;
    alias: string;
    jType: string;
    arms: number;
    icon: string;
    poles: number;
    code: string;
    address: string;
    place: string;
    state: string;
    pin: string;
    priority: PriorityType;
    country: string;
    isActive: boolean;
    isTrafficSignal: boolean;
    latitude: number;
    longitude: number;
    ticketStatus: TicketStatus;
    junctionStatus: TicketStatus;
    vendorDetails: AtsAcLdgr;
    companyID: number;
    customer:MstCustomer
    site: AtsSubsidiarySite
}

export interface GetJunctionWithOutTokenResult{
  GetJunctionWithOutToken:AtsJunctions
}